<div class="bid-example">
  <h3 *nzModalTitle>Macros overview</h3>
  <div class="row b-row">
    <div class="col-12">
      <table>
        <ng-container *ngFor="let macro of data.macrosList">
          <tr *ngIf="macro.desc && macro.desc.length > 0">
            <td>{{macro.name}}</td>
            <td>{{macro.desc}}</td>
          </tr>
        </ng-container>
      </table>

    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="close()">Close</button>
  </div>
</div>